import {useEffect, useState} from "react";
import {
    fetchSeasonCallback,
    fetchSerieCallback,
    postShareSquadflixEpisode, postShareSquadflixMovie,
    searchPage
} from "../../../cap17drive/api/cap17drive-api";
import {cn} from "../../../../utils/utils";
import './shareSquadflixForm.css';
import ItemsHorizontalScroll from "../../../cap17drive/shared/itemsHorizontalScroll/itemsHorizontalScroll";
import ItemDetailsToView from "../../../cap17drive/shared/itemDetailsView/itemDetailsToView";
import TmdbResultCard from "../../../cap17drive/tmdbResultCard/tmdbResultCard";
import {FormattedMessage, useIntl} from "react-intl";
import auth from "../../../../utils/authentication";
import {fetchSeason} from "../../../cap17drive/actions";
import {toast} from "react-toastify";
import EpisodeResultCard
    from "../../../cap17drive/movies/serieDetails/seasonDetails/episodeResultCard/episodeResultCard";

const defaultSelectedResult = {
    title: "Busca y selecciona algo!"
}

const ShareSquadflixForm = ({file, onClose, onConfirmShare}) => {

    const intl = useIntl();
    const [query, setQuery] = useState("");
    const [type, setType] = useState("movies");
    const [results, setResults] = useState([]);
    const [seasons, setSeasons] = useState([]);
    const [episodes, setEpisodes] = useState([]);
    const [selectedResult, setSelectedResult] = useState(defaultSelectedResult);
    const [selectedSeason, setSelectedSeason] = useState(undefined);
    const [selectedEpisode, setSelectedEpisode] = useState(undefined);

    const makeSearch = () => {
        if (!query?.length) return;
        searchPage(query, 1, type).then((res) => {
            setResults(res.results);
        });
    }

    const handleInputKeyDown = (event) => {
        if (event.key === 'Enter') {
            makeSearch();
        }
    }

    const getDate = (item) => {
        return item.release_date ?? item.first_air_date;
    }

    useEffect(() => {
        makeSearch();
        if(type !== "movie" && selectedResult.isMovie === false) {
            return;
        }
        setSelectedResult(defaultSelectedResult);
    }, [type])

    useEffect(() => {
        let lastEpisodeShared = sessionStorage.getItem("last-squadflix-publish-history");

        requestAnimationFrame(() => {
            if(lastEpisodeShared) {
                lastEpisodeShared = JSON.parse(lastEpisodeShared);
                setType(lastEpisodeShared.type);
                setSelectedResult(lastEpisodeShared.selectedResult);
                setSelectedSeason(lastEpisodeShared.selectedSeason);
                setSelectedEpisode(lastEpisodeShared.selectedEpisode);
            }
        });

    }, []);

    useEffect(() => {
        setSeasons([]);
        if(seasons.length > 0) {
            setSelectedSeason(undefined);
        }
        if (!selectedResult.id || type === "movies") {
            return;
        }

        fetchSerieCallback(selectedResult.id, auth.currentUser.uid).then(res => {
            const serieSeasons = res.seasons.map(x => ({
                show_id: res.id,
                season_number: x.season_number,
                title: x.name
            }));
            if (!serieSeasons?.length) {
                toast.error(intl.formatMessage({id: "share-squadflix-form.serie-no-seasons.error"}))
            }
            setSeasons(serieSeasons)
            if(!selectedSeason) {
                setSelectedSeason(serieSeasons.find(x => x.season_number == 1) ?? serieSeasons[0])
            }
        });
    }, [selectedResult]);

    useEffect(() => {
        if (!selectedResult?.id || !selectedSeason) {
            setEpisodes([]);
            setSelectedEpisode(undefined);
            return;
        }
        fetchSeasonCallback(selectedSeason.show_id, selectedSeason.season_number, auth.currentUser.uid).then(res => {
            setEpisodes(res.episodes);
            if(!selectedEpisode) {
                setSelectedEpisode(res.episodes[0]);
            }
        })

    }, [selectedSeason, selectedResult]);

    const handleConfirm = () => {
        if(type !== "movie") {
            sessionStorage.removeItem("last-squadflix-publish-history");
            sessionStorage.setItem("last-squadflix-publish-history", JSON.stringify({selectedResult, selectedSeason, selectedEpisode, type}));
        }

        const releaseDate = getDate(selectedResult);
        const body = {
            tmdb_result: {
                id: selectedResult.id,
                poster_path: selectedResult.poster_path,
            },
            selectedEpisode: {
                season_number: selectedSeason?.season_number,
                episode_number: selectedEpisode?.episode_number,
                name: selectedEpisode?.name,
                still_path: selectedEpisode?.still_path,
            },
            basicUrl: file.storeUrl,
            releaseDate: releaseDate ? new Date(releaseDate).toISOString() : undefined,
            title: selectedResult.title ?? selectedResult.name
        }

        if(selectedEpisode) {
            postShareSquadflixEpisode(body).then(() => {
                toast.success(intl.formatMessage({id: "share-squadflix-form.success"}));
                onConfirmShare?.();
            }).catch(() => {
                toast.error(intl.formatMessage({id: "share-squadflix-form.error"}));
            });
        } else {
            delete body.selectedEpisode;
            postShareSquadflixMovie(body).then(() => {
                toast.success(intl.formatMessage({id: "share-squadflix-form.success"}));
                onConfirmShare?.();
            }).catch(() => {
                toast.error(intl.formatMessage({id: "share-squadflix-form.error"}));
            });
        }

    }

    return (
        <div>
            <div className="d-flex justify-content-between align-items-center">
                <h4 className="modal-title">Compartir en SquadFlix</h4>
                <button type="button" className="btn-close" onClick={onClose}></button>
            </div>
            <hr/>
            <div className="form-floating position-relative">
                <input
                    onKeyDown={handleInputKeyDown}
                    value={query} onChange={e => setQuery(e.target.value)} type="text" className="form-control"
                    id="tmdbShareFormSearch" placeholder="" required/>
                <button
                    onClick={makeSearch}
                    style={{
                        opacity: query.length > 0 ? 1 : 0.2,
                        background: "none",
                        border: "none",
                        position: "absolute",
                        display: "flex",
                        alignItems: "center",
                        height: "100%",
                        width: "40px",
                        justifyContent: "center",
                        top: 0,
                        right: 0,
                        transition: "opacity 0.25s",
                    }}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                </button>
                <label htmlFor="tmdbShareFormSearch">¿Qué estás buscando?</label>
            </div>
            <div className="row">
                <div
                    onClick={() => setType("series")}
                    className={cn("col text-center shareSquadflixForm__type mb-0 pb-1 pt-3", type != "movies" && "shareSquadflixForm__selected-type")}>
                    Series
                </div>
                <div
                    onClick={() => setType("movies")}
                    className={cn("col text-center shareSquadflixForm__type mb-0 pb-1 pt-3", type == "movies" && "shareSquadflixForm__selected-type")}>
                    Películas
                </div>
            </div>
            <div className="mt-3" style={{height: "160px"}}>
                <ItemsHorizontalScroll>
                    {results.map(result => (
                        <ItemDetailsToView key={result.id} onClick={() => setSelectedResult(result)} item={result}
                                           description={getDate(result) && new Date(getDate(result)).toLocaleDateString()}
                                           title={""}/>
                    ))}
                </ItemsHorizontalScroll>
            </div>
            <hr/>
            <div className="mt-3">
                <div style={{height: "190px"}}>
                    <TmdbResultCard linked={false} props={selectedResult}/>
                    {selectedEpisode &&
                        <EpisodeResultCard nextEpisodeInfo customOnClick={() => {
                        }} nextInfoText="" forceSmall showSpoiler episode={selectedEpisode}/>}
                </div>
                <div className="row ms-1 me-1 gap-1">

                    <select style={{opacity: type === "movies" ? 0 : 1}}
                            disabled={type === "movies" || !selectedResult.id}
                            className="form-select col shareSquadflixForm__serieDetailsSelector"
                            onChange={e => setSelectedSeason(seasons.find(x => x.season_number == e.target.value))}>
                        {seasons.map(season => (
                            <option key={season.season_number}
                                    value={season.season_number}
                                    selected={selectedSeason?.season_number === season.season_number}>
                                {season.title}
                            </option>))}
                    </select>
                    <select style={{opacity: type === "movies" ? 0 : 1}}
                            disabled={type === "movies" || !selectedResult.id}
                            className="form-select col shareSquadflixForm__serieDetailsSelector"
                            onChange={e => setSelectedEpisode(episodes.find(x => x.episode_number == e.target.value))}>
                        {episodes.map(episode => (
                            <option key={episode.episode_number}
                                    value={episode.episode_number}
                                    selected={selectedEpisode?.episode_number === episode.episode_number}>
                                <FormattedMessage id="squadflix.serie.episode"/> {episode.episode_number}
                            </option>))}
                    </select>
                    <button className="btn btn-secondary col"
                            onClick={handleConfirm}
                            disabled={!selectedResult.id || (type !== "movies" && (!selectedEpisode || !selectedSeason))}>
                        <FormattedMessage id="modal.confirm"/>
                    </button>
                </div>
            </div>
        </div>
    )

}

export default ShareSquadflixForm;
